import { Id } from "./Id";
import { deepCopy } from "./data-helpers";
import { Validator, validator } from "./validation";

export class InMemoryRecords<TId extends Id, TRecord extends { id: TId }>
{
  private readonly idValidator:     Validator<TId>;
  private readonly recordValidator: Validator<TRecord>;

  private records: TRecord[] = [];

  constructor({ idValidator, recordValidator }: {
    idValidator?:     Validator<TId>,
    recordValidator?: Validator<TRecord>,
  })
  {
    this.idValidator     = idValidator     || validator();
    this.recordValidator = recordValidator || validator();

    // throw new Error(`xxxx idValidator must be defined. It is ${this.idValidator}.`);
    // if (this.idValidator === undefined) throw new Error(`xxxx idValidator must be defined. It is ${this.idValidator}.`);
  }

  single(id: TId): TRecord
  {
    if (id === undefined) throw new Error(`Parameter id must be defined. It is ${id}.`);
    if (id === null     ) throw new Error(`Parameter id must be defined. It is ${id}.`);

    if (!this.idValidator.isValid(id)) throw new Error(`Parameter id must be valid. Error report: ${JSON.stringify({ id, errors: this.idValidator.validationErrors(id) }, null, 2)}.`);

    const result = this.records.find(_ => Id.areEqual(_.id, id));
    if (result === undefined) throw new Error(`Record with id ${id} not found.`);

    return deepCopy(result);
  }
  all(): TRecord[]
  {
    return deepCopy(this.records);
  }

  insert(record: TRecord): void
  {
    if (record === undefined) throw new Error(`Parameter record must be defined. It is ${record}.`);
    if (record === null     ) throw new Error(`Parameter record must be defined. It is ${record}.`);

    if (!this.recordValidator.isValid(record)) throw new Error(`Parameter record must be valid. Error report: ${JSON.stringify({ record, errors: this.recordValidator.validationErrors(record) }, null, 2)}.`);

    this.records.push(
      deepCopy(record)
    );
  }
  insertAll(records: TRecord[]): void
  {
    if (records === undefined) throw new Error(`Parameter records must be defined. It is ${records}.`);
    if (records === null     ) throw new Error(`Parameter records must be defined. It is ${records}.`);

    if (!records.every(this.recordValidator.isValid)) throw new Error(`Parameter records must be valid. Error report: ${JSON.stringify(records.filter(_ => !this.recordValidator.isValid(_)).map(_ => ({ record: _, errors: this.recordValidator.validationErrors(_) })), null, 2)}.`);

    this.records.push(
      ...deepCopy(records)
    );
  }

  replaceAll(records: TRecord[]): void
  {
    if (records === undefined) throw new Error(`Parameter records must be defined. It is ${records}.`);
    if (records === null     ) throw new Error(`Parameter records must be defined. It is ${records}.`);

    if (!records.every(this.recordValidator.isValid)) throw new Error(`Parameter records must be valid. Error report: ${JSON.stringify(records.filter(_ => !this.recordValidator.isValid(_)).map(_ => ({ record: _, errors: this.recordValidator.validationErrors(_) })), null, 2)}.`);

    this.records.splice(
      0,
      this.records.length,
      ...deepCopy(records)
    );
  }
}
